import { Check } from "lucide-react";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  ARCHIVE_MODE_OPTIONS,
  type OpportunityArchiveMode,
} from "./opportunityFilterTypes";

interface OpportunityArchiveFilterContentProps {
  value: OpportunityArchiveMode;
  onChange: (mode: OpportunityArchiveMode) => void;
}

/**
 * Dropdown body for the Archive filter: choose whether the board shows Active
 * opportunities only, Archived only, or All.
 * @param value - The current archive view mode
 * @param onChange - Called with the chosen archive view mode
 * @returns The archive-filter dropdown content
 */
export function OpportunityArchiveFilterContent({
  value,
  onChange,
}: OpportunityArchiveFilterContentProps) {
  return (
    <Command>
      <CommandList>
        <CommandGroup>
          {ARCHIVE_MODE_OPTIONS.map((option) => (
            <CommandItem
              key={option.value}
              value={option.value}
              onSelect={() => onChange(option.value)}
              className="justify-between"
            >
              {option.label}
              {value === option.value && <Check className="h-4 w-4" />}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
